$(function () {

    DECIX.listjs = DECIX.listjs || {};

    DECIX.listjs.init = function () {

        $(".listjs").each(function () {

            var obj = $(this).attr("id");
            var fields = $(this).data("index-fields");
            var defaultSorting = $(this).data("default-sorting");
            var options = {page: 9999, valueNames: fields};

            $(this).find(".search").removeClass("hidden");

            var list = new List(obj, options);

            if (defaultSorting) {
                list.sort(defaultSorting[0], {order: defaultSorting[1] ? defaultSorting[1] : "asc"});
            }

        });

    };

    DECIX.listjs.init();

});
